



















































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import ProductRelatedApi from '@/api/goods/related/index'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import appconst from '@/lib/appconst'
@Component({
  components: {
    CustomForm,
  },
})
export default class RelatedProduct extends AbpBase {
  uploadUrl: string = ''
  templateUrl: string = ''
  exporting: boolean = false
  filters = [
    {
      label: '输入搜索：',
      type: 'input',
      props: {
        placeholder: '分组名称',
      },
      key: 'filter',
    },
  ]

  loading = false
  pager = {
    pageIndex: 1,
    pageSize: 10,
    total: 0,
  }
  columns = [
    {
      title: '分组名称',
      key: 'name',
    },
    {
      title: '款数',
      key: 'count',
    },
    {
      title: '操作',
      key: 'action',
      slot: 'action',
      width: 200,
    },
  ]
  data = []

  mounted() {
    this.uploadUrl = `${appconst.remoteServiceBaseUrl}/api/productManagement/relatedProduct/importExcelProduct`
    this.templateUrl = `${appconst.remoteServiceBaseUrl}/api/productManagement/relatedProduct/importNameCodeGroupingTemp`
    this.loadData()
  }
  /**
   * 下载模板
   */
  downloadTemplate() {
    location.href = this.templateUrl
  }
  onPageChange(pageIndex) {
    this.pager.pageIndex = pageIndex
    this.loadData()
  }
  loadData() {
    let form: any = this.$refs.lineForm
    console.log(form)
    const formData = (form && form.getForm()) || { filter: '' }
    this.loading = true
    ProductRelatedApi.getList(formData.filter, this.pager.pageSize, this.pager.pageIndex).then((res) => {
      this.pager.total = res.data.totalCount
      this.data = res.data.items
      this.loading = false
    })
  }
  edit(id) {
    this.$router.push({ name: 'productRelatedEdit', params: { id: id } })
  }
  deleteItem(id: string) {
    ProductRelatedApi.deleteRelatedProduct(id).then((res) => {
      this.$Message.success('删除成功')
      this.loadData()
    })
  }
  submitChange(form, valid) {
    if (valid) {
      this.loadData()
    }
  }
  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }
  /**
   * 导入数据
   */
  uploadSuccess(res) {
    this.$Message.success('上传文件成功，导入比较耗时，请稍后刷新查看结果')
    this.loadData()
  }
  /**
   * 导出excel表格
   */
  exportExcel() {
    this.exporting = true
    // let refForm: any = this.$refs.lineForm
    // const form = refForm.getForm()
    // let dateTimeRange = form['dateTimeRange']
    // console.log(form)
    ProductRelatedApi.exportRelatePorduct()
      .then((res) => {
        console.log(res)
        this.exporting = false
        this.download(res.data)
      })
      .catch((err) => {
        this.exporting = false
      })
  }
  download(data) {
    if (!data) {
      return
    }
    let url = window.URL.createObjectURL(new Blob([data]))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', '相关商品.xlsx')

    document.body.appendChild(link)
    link.click()
  }
}
